function observeFacetActiveCallback(resultsWrapper, templateButton) {
    // Make a button for all active facets and append after [data-target="filterlist"]
    const activeFacets = getActiveFWPfacets()

    // get the filterlist element
    const filterList = resultsWrapper.querySelector('[data-target="filterlist"]')

    // remove all children from the filterlist element
    filterList.innerHTML = ""

    // TODO: refactor away from nested loops if time permits
    // loop over all active facets
    activeFacets.forEach((facet) => {
        facet.values.forEach((value) => {
            const button = templateButton.content.cloneNode(true)
            // get the button element
            const buttonElement = button.querySelector("button")
            // set the button text
            buttonElement.querySelector("span").textContent = value.label

            // set the button data attribute
            buttonElement.dataset.filter = facet.facet

            // append the button to the filterlist
            filterList.appendChild(button)

            buttonElement.addEventListener("click", () => {
                // Find the list with facet.facet as the data attribute name
                const list = document.querySelector(`[data-name="${facet.facet}"]`)
                // Find the list item with value as the data attribute value
                const listItem = list?.querySelector?.(`[data-value="${value.value}"]`)
                // click listItem if it exists
                listItem?.click?.()
            })
        })
    })
}

/**
 *
 * @returns {{values: {value: string, label: string}[], facet: *}[]}
 */
function getActiveFWPfacets() {
    return (
        Object.keys(FWP.facets)
            // filter out facet price
            .filter((facet) => facet !== "price")
            // filter out facet result_count
            .filter((facet) => facet !== "result_count")
            // filter out facet sorting
            .filter((facet) => facet !== "sorting")
            .map((facet) => {
                return {
                    facet,
                    values: FWP.facets[facet].map((value) => {
                        return {
                            value,
                            label: findLabelForFacetAndValue(facet, value),
                        }
                    }),
                }
            })
    )
}

function findLabelForFacetAndValue(facet, value) {
    const list = document.querySelector(`[data-name="${facet}"]`)
    const listItem = list?.querySelector?.(`[data-value="${value}"]`)
    return listItem?.querySelector(".facetwp-display-value").textContent
}

;(function () {
    const resultsWrapper = document.querySelector('[data-component="results"]')

    if (window.FWP === undefined) {
        return
    }

    if (!resultsWrapper) {
        return;
    }

    // get template button element from the results wrapper
    /**
     * @type {HTMLTemplateElement}
     */
    const templateButton = resultsWrapper.querySelector('[data-template="button"]')

    document.addEventListener("facetwp-loaded", function () {
        observeFacetActiveCallback(resultsWrapper, templateButton)

        if (getActiveFWPfacets().filter((facet) => facet.values.length > 0).length === 0) {
            resultsWrapper.querySelector("span").classList.add("!hidden")
        } else {
            resultsWrapper.querySelector("span").classList.remove("!hidden")
        }
    })

    document.addEventListener("facetwp-refresh", function () {
        observeFacetActiveCallback(resultsWrapper, templateButton)
        if (getActiveFWPfacets().filter((facet) => facet.values.length > 0).length === 0) {
            resultsWrapper.querySelector("span").classList.add("!hidden")
        } else {
            resultsWrapper.querySelector("span").classList.remove("!hidden")
        }
    })
})()
